module.exports = __webpack_public_path__ + "static/media/black-light.3114359f.svg";